import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type { WidthProps } from 'styled-system';
import { space, width } from 'styled-system';

import { Flex } from 'common/components/Flex';
import type { SpaceProps } from 'common/theme/system-types';

const ICON_SIZE = 18;
const CONTAINER_SIZE = 32;

const UnstyledEntryPointIcon = styled.img<SpaceProps & WidthProps>`
  ${width}
  ${space};
`;

const EntryPointIcon = (props: ComponentProps<typeof UnstyledEntryPointIcon>) => (
  <Flex width={CONTAINER_SIZE} justifyContent="center">
    <UnstyledEntryPointIcon width={ICON_SIZE} {...props} />
  </Flex>
);

export default EntryPointIcon;
